export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/index.8679448b.worker.js");
}
